export const styleConstantsV2 = {
  ///////////////////////// Primary /////////////////////////
  colorPrimary: "#095B6F",
  colorPrimaryHoverDark: "#094958",
  colorPrimaryHoverLight: "#C7E8F7",
  colorPrimaryMid: "#90C4D9",
  colorPrimaryBg: "#EDF9FF",

  ///////////////////////// Secondary /////////////////////////
  colorSecondary: "#AB016F",
  colorSecondaryHoverDark: "#940762",
  colorSecondaryHoverLight: "#F8D9EB",
  colorSecondaryMid: "#EECCE2",
  colorSecondaryBg: "#F8EAF4",
  colorSecondaryPressed: "#6F095B",

  ///////////////////////// Tertiary /////////////////////////
  colorTertiary: "#403BA4",
  colorTertiaryHoverDark: "#2D297A",
  colorTertiaryHoverLight: "#E0DFEE",
  colorTertiaryMid: "#A09ECF",
  colorTertiaryBg: "#EDEDF7",

  ///////////////////////// System /////////////////////////
  colorWhite: "#FFFFFF",
  colorBlack: "#190402",
  colorGrey: "#816868",
  colorGrey50: "#ACA3A3",
  colorGrey30: "#D7D3D3",
  colorGrey20: "#EBE9E9",
  colorGrey10: "#F7F6F6",

  ///////////////////////// Semantic /////////////////////////

  colorSuccess: "#298738",
  colorSuccessBg: "#EAF3EB",
  colorError: "#BC3E3E",
  colorErrorBg: "#FAF0F0",
  colorWarning: "#F8C158",
  colorWarningBg: "#FEF8EF",

  colorBackgroundBackdrop: "rgba(129, 104, 104, 0.7)",

  // see if we need these
  colorLink: "#A72384",
  colorBackgroundWeb: "#DFE7EE",
  colorLineBreak: "#EBEBEB",

  // Spaces
  spacing4: 4,
  spacing8: 8,
  spacing12: 12,
  spacing16: 16,
  spacing24: 24,
  spacing32: 32,
  spacing40: 40,
  spacing48: 48,
  spacing56: 56,
  spacing64: 64,
  spacing72: 72,
  spacing80: 80,
  spacing88: 88,
  spacing96: 96,

  // Border radius
  borderRadius4: 4,
  borderRadius8: 8,
  borderRadius12: 12,
  borderRadius16: 16,
  borderRadius20: 20,
  borderRadius24: 24,
  borderRadius30: 30,

  // Font sizes (desktop and mobile)
  // Sizes for brand text
  fontSizeDesktopH1: 32,
  fontSizeDesktopH2: 26,
  fontSizeDesktopH3: 20,
  fontSizeDesktopH4: 16,
  fontSizeDesktopH5: 12,
  // mobile
  fontSizeMobileH1: 28,
  fontSizeMobileH2: 24,
  fontSizeMobileH3: 18,
  fontSizeMobileH4: 14,
  fontSizeMobileH5: 12,

  // Sizes for body text
  fontSizeBodyExtraLarge: 18,
  fontSizeBodyLarge: 16,
  fontSizeBodyMedium: 14,
  fontSizeBodySmall: 12,
};
